/* eslint-disable no-unused-vars*/
/* eslint-disable no-useless-escape*/
/* eslint-disable react/prop-types*/
/* eslint-disable*/

import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useBackstage } from './backstage';
import { UserContext } from "../context/user/UserContext";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import useAuth from "../useAuth";
import useWebSocket, { ReadyState } from 'react-use-websocket';
import { Button, Divider, Menu, MenuItem } from '@mui/material';
import { alpha, styled } from "@mui/material/styles";
import ArchiveIcon from "@mui/icons-material/Archive";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { getApiUrl, APPFACTOR, newSessionUID,DEBUG_LEVEL_VAL } from "./commons"
import { SSS_ } from "./APPF_ICONS"
import { EventLogIcon } from "./eventlog/EventLog";
import {
  NavApp,
  NavDashboard,
  NavDeploy,
  NavDesigner,
  NavDiscovery,
  NavEventLog,
  NavForge,
  NavLogout,
  NavMonitor,
  NavMultiverse,
  NavReports,
  NavScan,
  NavSecurity,
} from "../orion/assets/icons/navIcons";
import { poolData} from "../UserPool";
import LOCAL_STORAGE_KEY from "../service/local-storage/constant";
import isForgeEnabled from "../service/local-storage/forge";
import UI_VERSION from "../constant";
import ThemeToggler from "./theme-toggler";
import { ThemeContext } from "./theme-toggler/theme-context";
import { THEME_KEY } from "./theme-toggler/constant";
import ProjectInfoBar from './ProjectInfoBar'
import useProjectStore from '../store/projectStore';
import "./style/SidebarNav.css";
import { EstateVoicePill, pageSearchField, typeInto } from "./EstateAskMic";
import { hrefFor, resolveAsk } from "../site/siteMap";
import { act as butlerAct, canThink } from "../butler/agent";
import { whenSearchField } from "../site/webmcp";
import SettingsDialog from "./SettingsDialog";
import LogoutWarning from "./LogoutWarning";
import { applyNavConfig } from "./navEntries";
import { askLog, setAskHandler, startTyping, startVoice, voiceState, voiceSupported, voiceWorking } from "./estateVoice";
import "./estate-ask.css";
import { probedPassword } from "./EnterSecretPassword";

/**
 * What the estate can answer, from the mark.
 * ---------------------------------------------------------------------------
 * Each of these is a question someone actually arrives with, and each one
 * lands on the page that answers it with the view already set - a link that
 * says `?view=cards&sev=critical` rather than a page the reader then has to
 * configure. The pages read those words themselves (see HostTable and
 * ApplicationTable), so a link can be sent to someone and still arrive on the
 * same answer.
 * ---------------------------------------------------------------------------
 */
/* Where the answer is left for the page that is about to open.
   -------------------------------------------------------------------------
   The link carries the same words in its query, so one can be copied and sent
   - but the app bounces a fresh navigation through its login check, which
   re-routes to the path WITHOUT the query, and the card views mount lazily
   after that. So the intent is also left here, where nothing on the way can
   drop it, and the page takes it the moment it opens. */
export const ESTATE_ASK_KEY = "estate.ask";

export function leaveEstateAsk(intent) {
  try { sessionStorage.setItem(ESTATE_ASK_KEY, JSON.stringify(intent)); } catch (e) { /* private window */ }
}

/** Taken once: a question is answered the first time the page opens on it. */
export function takeEstateAsk(page) {
  try {
    const raw = sessionStorage.getItem(ESTATE_ASK_KEY);
    if (!raw) return null;
    const ask = JSON.parse(raw);
    if (!ask || ask.page !== page) return null;
    sessionStorage.removeItem(ESTATE_ASK_KEY);
    return ask;
  } catch (e) { return null; }
}

/**
 * The product's mark, drawn rather than fetched.
 * ---------------------------------------------------------------------------
 * It used to be a background image on the toggle, which is fine for a picture
 * and no use at all for a light that has to travel its OUTLINE: a background
 * is not a shape anything else can be cut to. Inline, the path is here to be
 * filled with its own gradient, as it has always been - and to be the shape
 * the light is masked to.
 *
 * The light that runs its outer edge is not drawn here: it is the cards' own
 * conic sweep, masked down to this path's outer contour (see
 * .estate-mark__sweep in estate-ask.css, which says how that contour was
 * picked out of the three this path holds).
 * ---------------------------------------------------------------------------
 */
const MARK_D = "M33.0083 8.85659L32.6651 8.66629L17.0023 0L1.33774 8.66629L0.994523 8.85659L0 9.40742V19.8389L9.32568 24.9983L17.0006 20.7519L24.6755 25L34.0029 19.8389V11.0009V9.40742L33.0067 8.85659H33.0083ZM17.0023 3.07573L29.8858 10.2042L24.6788 13.0862L17.0023 8.83977L9.32568 13.0862L4.11871 10.2042L17.0023 3.07573ZM24.6771 21.9242L17.0023 17.6762L9.32735 21.9242L2.68052 18.2455V12.4832L9.32735 16.1602L17.0039 11.9139L24.6805 16.1602L31.3273 12.4814V18.2439L24.6805 21.9226L24.6771 21.9242Z";

function EstateMark() {
    return (
        <svg className="estate-mark" viewBox="0 0 36 26" fill="none"
            xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
            <defs>
                <linearGradient id="estate-mark-fill" x1="0" y1="7.54129" x2="30.7582" y2="52.8764"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.122862" stopColor="#FF3710" />
                    <stop offset="1" />
                </linearGradient>
            </defs>
            <path d={MARK_D} fill="url(#estate-mark-fill)" />
        </svg>
    );
}

const ESTATE_QUESTIONS = [
    {
        label: "Hosts with a critical vulnerability",
        /* the estate as cards, the lens open on critical, filtering rather
           than pointing - so what is left on the stage is the answer */
        to: "/discovery?view=cards&sev=critical&only=1",
        ask: { page: "discovery", cards: true, severity: "critical", only: true },
    },
    {
        label: "Applications with vulnerabilities",
        to: "/apps?view=cards&lens=vulnerable",
        ask: { page: "apps", cards: true, lens: "vulnerable" },
    },
    {
        label: "Applications I can document",
        /* "can" is the test Forge itself applies: a linked repository to run
           against (see canGenerateDocs on the applications table) */
        to: "/apps?view=cards&lens=documentable",
        ask: { page: "apps", cards: true, lens: "documentable" },
    },
    {
        label: "Every CVE in my estate",
        /* every severity, and the funnel down: the stage keeps the whole
           estate while the findings column lists what was found on it */
        to: "/discovery?view=cards&sev=all",
        ask: { page: "discovery", cards: true, severity: "all" },
    },
    {
        label: "My assessed applications",
        to: "/assess",
    },
];

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "right"
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "right"
        }}
        {...props}
    />
))(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 4,
        marginTop: theme.spacing(0.5),
        minWidth: 260,
        color: theme.palette.grey[300],
        boxShadow:
            "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 8px 10px -4px, rgba(0, 0, 0, 0.05) 0px 3px 5px -2px",          
        "& .MuiMenu-list": {
            padding: "2px 0"
        },
        /* The questions' rows are dressed entirely in estate-ask.css. */
        "& .MuiMenuItem-root": {
            fontSize: 12,
            minHeight: 28,
            padding: "4px 8px",
            "& .MuiSvgIcon-root": {
                fontSize: 14,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1)
            },
            "&:active": {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity
                )
            }
        }
    }
}));

function SidebarNav() {
    /* ...and whether the two entries that are not for everybody are drawn at
       all. Off unless the chord has been pressed; see backstage.js. */
    const backstage = useBackstage();
    const currentProjectId = useProjectStore(s => s.currentProjectId);
    const currentSEnv = useProjectStore(s => s.currentSEnv);
    const [appf_tenant_info] = useState(localStorage.appf_tenant_info?JSON.parse(localStorage.appf_tenant_info):{});
    const deployEnabled = typeof appf_tenant_info.sku!=="undefined"?( appf_tenant_info?.sku == "full-internal" || appf_tenant_info?.sku?.toLowerCase().indexOf("deploy") > -1 ) :false
    const [uiVersion, setUIVersion] = useState(localStorage.getItem(LOCAL_STORAGE_KEY.UI_VERSION))
    const [currentWSURL,setCurrentWSURL] = useState(`${localStorage.wsURL || APPFACTOR.__DEFAULT_WS_URL}:${localStorage.wsPort || APPFACTOR.__DEFAULT_PORT}/ws/v2`)
    const { gdata,setGdata } = useContext(UserContext);
    const [anchorElScan, setAnchorElScan] = useState(null);
    const [notificationsEnabled] = useState(false)
    
    const [vSock, setVSock] = useState({
        v1: {
            available: false,
        },
        v2: {
            available: false,
        }
    });

    const { logout } = useAuth();
    const navigate = useNavigate();
    // Sidebar is always in full mode now; removed menuLow/minimized logic
    const [shouldIConnect, setShouldIConnect] = useState(false);
    const [init, setInit] = useState(0);
    const [checkOldVersion, setCheckOldVersion] = useState(0);

    const [sessionUID, setSessionUID] = useState(newSessionUID());
    const [height, setHeight] = useState(0);
    const [showWindow, setShowWindow] = useState(false);
    /* The settings window, opened from the rail. */
    const [settingsOpen, setSettingsOpen] = useState(false);
    /* ...and the question asked before the way out. */
    const [logoutAsking, setLogoutAsking] = useState(false);

    /* The rail is drawn as markup and arranged by the setting: after every
       render, each entry is told where to stand, whether to stand at all, and
       what to call itself (see navEntries). Deliberately without a dependency
       list - a render is exactly when the labels go back to what the markup
       says, and this is what puts them right again. */
    useEffect(() => { applyNavConfig(); });
    const [logoRef, setLogoRef] = useState();
    const logoReff = useRef();
    /* Holding the pointer on the mark opens it, so the questions are findable
       without knowing they are there; moving off before it fires calls it
       back. */
    const askHoverTimer = useRef(null);
    // Theme context for explicit Light/Dark switching
    const { theme } = useContext(ThemeContext);
    const isDarkMode = theme === THEME_KEY.DARK;


    const openEstateAsk = useCallback(() => {
        const mark = logoReff.current;
        if (!mark) return;
        setLogoRef(mark);
        setShowWindow(true);
    }, []);

    const closeEstateAsk = useCallback(() => {
        setShowWindow(false);
        setLogoRef(null);
    }, []);

    const askQuestion = useCallback((q) => {
        if (!q) return;
        closeEstateAsk();
        if (q.ask) leaveEstateAsk(q.ask);
        navigate(q.to);
    }, [closeEstateAsk, navigate]);

    /* What was said, put where it would have been typed.
       -----------------------------------------------------------------------
       The search field of the page that is open, filled through the element's
       own setter so React sees the change (see typeInto). A page with no
       search of its own has nothing to fill, so the words travel to the estate
       instead - as cards, which is the view a search is worth something in. */
    const askAloud = useCallback(async (text) => {
        const said = (text || "").trim();
        if (!said) { askLog("nothing to act on"); return; }
        closeEstateAsk();

        /* First: was that a place rather than a word? "Go to the forge wiki"
           is a journey; "forge" typed on the applications page is a search for
           the word forge, and a page that walked off because of it would be a
           page nobody could search. So only a page named outright, or a verb
           in front of one, moves anything (see resolveAsk). */
        const going = resolveAsk(said);

        /* ...and if the words are not a place by that reading, the butler gets
           them - which is most of what people actually say. It decides between
           the SAME tools this app publishes to WebMCP, so what it does is what
           an agent in the browser would have done, and it is allowed to say
           "not a journey", in which case the words carry on to the page's own
           search exactly as before.

           Only when a model is already up: waking one here would put a second
           on a keystroke somebody expected to be instant. */
        if (!going && canThink()) {
            voiceWorking("thinking…");
            const done = await butlerAct(said, { env: { forge: isForgeEnabled(), deploy: deployEnabled } });
            voiceWorking(null);
            if (done.did) return;
        }
        if (going) {
            /* "critical" in "show critical machines" is the lens, not a word to
               look for; whatever is left after the filters have taken theirs is
               the search. */
            const { href, left } = hrefFor(going.page, {
                filters: { ...going.filters, ...(going.rest ? { search: going.rest } : {}) },
            });
            /* read before the journey: see whenSearchField */
            const leaving = pageSearchField();
            const staying = window.location.pathname === href.split("?")[0];
            askLog(
                `"${said}" is a place:`, going.page.label,
                Object.keys(going.filters || {}).length ? going.filters : "",
                going.rest ? `· looking for "${going.rest}"` : "",
                "→", href,
            );
            navigate(href);
            /* ...and a search the address could not carry is typed into the
               page's own field once that page is up - which on a cold one is
               seconds away, so it is waited for rather than guessed at. */
            if (going.rest && left.includes("search")) {
                whenSearchField(href.split("?")[0], { not: staying ? null : leaving }).then(there => {
                    if (!there) { askLog(`${going.page.label} has no search field to put "${going.rest}" in`); return; }
                    typeInto(there, going.rest);
                    there.focus();
                    askLog(`typed "${going.rest}" into ${going.page.label}'s search`);
                });
            }
            return;
        }

        const field = pageSearchField();
        if (field) {
            askLog(`no page is called that — searching this page for "${said}"`);
            typeInto(field, said);
            field.focus();
            return;
        }

        askLog(`no page is called that, and this one has no search — taking "${said}" to the estate`);
        leaveEstateAsk({ page: "discovery", cards: true, query: said });
        navigate(`/discovery?view=cards&q=${encodeURIComponent(said)}`);
    }, [closeEstateAsk, navigate]);

    /* However the words arrive - spoken into the pill or typed into it - this
       is what is done with them. Registered once, so the pill can act without
       knowing anything about routes. */
    useEffect(() => setAskHandler(askAloud), [askAloud]);

    /* Three taps of Ctrl, nothing else held, within a second and a half: the
       keyboard's way to the same menu, for someone whose hands are already
       there. Counted on keyUP - Ctrl held down repeats, and a held key is not
       a tap. */
    useEffect(() => {
        let taps = 0;
        let at = 0;
        const onKeyUp = (e) => {
            if (e.key !== "Control") { taps = 0; return; }
            const now = performance.now();
            taps = now - at > 600 ? 1 : taps + 1;
            at = now;
            if (taps >= 3) {
                taps = 0;
                openEstateAsk();
            }
        };
        window.addEventListener("keyup", onKeyUp);
        return () => window.removeEventListener("keyup", onKeyUp);
    }, [openEstateAsk]);

    /* Asking out loud, on Ctrl+Shift+A.
       -----------------------------------------------------------------------
       Not a row on the menu any more: the five questions are what the menu is
       for, and a microphone among them was a sixth thing of a different kind.
       It is a shortcut instead - press, say it, and the words land in the
       page's search - so it costs the menu nothing and costs a keystroke to
       reach. The pill in the corner is what says it is listening.

       Read from `code`, so it is the A key wherever the layout puts it. It
       OPENS a sitting and does not close one: pressing it twice used to stop
       the listening, which is a thing you do by accident while trying to start
       it again. The pill's Stop button ends it, and Enter and Escape do too. */
    useEffect(() => {
        const onKey = (e) => {
            if (e.code !== "KeyA" || !e.ctrlKey || !e.shiftKey || e.altKey || e.metaKey) return;
            /* ...including while something is being typed into. It used to
               stand down there, which is exactly where someone reaches for it:
               click into the search, find it slow to type, press the shortcut -
               and nothing happened at all. Ctrl+Shift+A is not a thing anyone
               presses by accident in a text field. */
            e.preventDefault();
            if (!voiceSupported()) {
                /* no speech in this browser at all: the ask is still the ask,
                   so it opens with a field instead of a microphone */
                askLog("this browser has no speech recognition — asking in writing instead");
                startTyping();
                return;
            }
            /* already listening: this is not the way to stop */
            if (voiceState().state === "listening") {
                askLog("already listening — press Stop on the pill, or Enter, to finish");
                return;
            }
            closeEstateAsk();
            startVoice(askAloud);
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [askAloud, closeEstateAsk]);

    useEffect(() => () => clearTimeout(askHoverTimer.current), []);

    /* While it is open, the numbers on the rows are keys. */
    useEffect(() => {
        if (!showWindow) return undefined;
        const onKey = (e) => {
            if (e.ctrlKey || e.altKey || e.metaKey) return;
            const at = Number(e.key) - 1;
            if (!Number.isInteger(at) || at < 0 || at >= ESTATE_QUESTIONS.length) return;
            e.preventDefault();
            askQuestion(ESTATE_QUESTIONS[at]);
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [showWindow, askQuestion]);

    useEffect(() => {
        window._g.vSock = vSock;
    }, [vSock]);

    useEffect(() => {
        if (!uiVersion) {
            setUIVersion(localStorage.getItem(LOCAL_STORAGE_KEY.UI_VERSION) || UI_VERSION.OLD);
        }

        if (checkOldVersion > 0) {
            let wsock_v1 = {};
            let wsURL = `${localStorage.wsURL || APPFACTOR.__DEFAULT_WS_URL}:${localStorage.wsPort || APPFACTOR.__DEFAULT_PORT}`;

            try {
                wsock_v1 = new WebSocket(wsURL);
                wsock_v1.onopen = function () {
                    if (wsock_v1.readyState == 1) {
                        setVSock(
                            {
                                v1: {
                                    available: true,
                                    url: wsURL
                                }
                                ,
                                v2: {
                                    available: false
                                }
                            }
                        );

                        wsock_v1.close();
                        wsock_v1 = null;

                        if(wsURL !== currentWSURL) {
                            setCurrentWSURL(wsURL);
                        }

                        setGdata(p => {
                            return {
                                ...p,
                               version:1
                            }
                        });

                        setShouldIConnect(true);
                    }
                }

                wsock_v1.onmessage = function () {}

                wsock_v1.onerror = function () {}
            }

            catch (e) {
                console.log(e);
            }
        }
    }, [checkOldVersion, currentWSURL, setGdata]);

    useEffect(() => {
        if (init > 0 && !(window._g.vSock?.v1?.available || window._g.vSock?.v2?.available)) {
            let wsock_v2 = {};
            let wsURL = `${localStorage.wsURL || APPFACTOR.__DEFAULT_WS_URL}:${localStorage.wsPort || APPFACTOR.__DEFAULT_PORT}/ws/v2`;

            try {
                wsock_v2 = new WebSocket(wsURL);
                wsock_v2.onopen = function () {
                    if (wsock_v2.readyState == 1) {
                        setVSock(
                            {
                                v1: {
                                    available: false,
                                },
                                v2: {
                                    available: true,
                                    url: wsURL
                                }
                            }
                        );

                        wsock_v2.close();
                        wsock_v2 = null;

                        // Only update if different to prevent infinite loop
                        if (wsURL !== currentWSURL) {
                            setCurrentWSURL(wsURL);
                        }

                        setGdata(p => {
                            return {
                                ...p,
                               version: 2
                            }
                        });

                        setShouldIConnect(true);
                    }
                }

                wsock_v2.onmessage = function () {}

                wsock_v2.onerror = function () {
                    setCheckOldVersion(p => (p + 1));
                }
            }

            catch (e) {
                console.log(e);
            }
        }
    }, [init, setGdata]); // Removed currentWSURL from dependencies to prevent loop


    useEffect(() => {
        const updateWindowDimensions = () => {
            const newHeight = window.innerHeight;

            setHeight(newHeight);
        };

        window.addEventListener("resize", updateWindowDimensions);

        return () => window.removeEventListener("resize", updateWindowDimensions)
    }, []);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const { sendMessage, lastMessage, readyState } = useWebSocket(currentWSURL,
        {
            onError: () => {},
            shouldReconnect: () => true,
            reconnectAttempts: 20,
            reconnectInterval: 1000,
        },
        shouldIConnect
    );

    const connectionStatus = {
        [ReadyState.CONNECTING]: 'Connecting',
        [ReadyState.OPEN]: 'Open',
        [ReadyState.CLOSING]: 'Closing',
        [ReadyState.CLOSED]: 'Closed',
        [ReadyState.UNINSTANTIATED]: 'Uninstantiated',
    }[readyState];



    useEffect(() => {
        setGdata(p => {
            return {
                ...p,
                connectionStatus,
                connected: connectionStatus == "Open"
            }
        });

        if (connectionStatus != "Open") {
            sendMessage(`
                {
                "type":"get_protocols",
                "id":"${sessionUID}"
                }
            `);
        }

        if (connectionStatus != "Open" && connectionStatus != "Connecting") {
            setVSock(() => {
                return {
                    v1: {
                        available: false
                    },
                    v2: {
                        available: false
                    }
                }
            });
        }

        window._g.connectionStatus = connectionStatus;

        // The socket is back but the version probe still says neither v1 nor v2
        // is available - it was cleared above when the connection dropped, and
        // only re-runs when init changes. Nothing bumped init on reconnect:
        // that happens for "connect" messages, and every scan or secret command
        // is a scanRaw one. So the outbound path below stayed shut and the page
        // could receive but never send until it was remounted, which is why
        // leaving the page and coming back appeared to fix a stalled scan page.
        //
        // This only terminates because `init` is NOT one of this effect's
        // dependencies. Add it - or let an exhaustive-deps autofix add it - and
        // the bump re-enters the effect, the guard below is still true against
        // an orchestrator exposing neither version, and it loops unbounded.
        // Keep `init` out of the dep array on the next line down.
        if (connectionStatus == "Open"
            && !(window._g.vSock?.v1?.available || window._g.vSock?.v2?.available)) {
            setInit(p => p + 1);
        }

        try{
            let me = document.querySelector('a[data-val="./scan"]')
            if (connectionStatus == "Open") {
                
                if( !me.classList.contains("connected")){
                    me.classList.add("connected");
                }
            }else{
                if( me.classList.contains("connected")){
                    me.classList.remove("connected");
                }
            }
        }catch(e){/**/ }
    }, [readyState, connectionStatus, setGdata]);

    function setAdditionalData(inData){
        let token = poolData.refreshToken();
        let url=getApiUrl(poolData.envURL)
        token = poolData.accessToken;

        try{
            if( window._g.hashicorp_vault_token ){
                inData["hashicorp_vault_token"] =`${ window._g.hashicorp_vault_token }`;
            }
        }catch(e){/**/ }
        if(localStorage[DEBUG_LEVEL_VAL] && `${localStorage[DEBUG_LEVEL_VAL]}`== "true"){
           inData["log_level"] ="debug";
        }
        inData["api_access_token"] =`${token}`;
        inData["api_url_prefix"] =`${url}`;
        inData["project_id"] =`${currentProjectId}`;
        inData["env_id"] =`${currentSEnv}`;
        // A password check carries the password it is testing, looked up by the
        // id of the request being sent. Everything else carries the live one.
        // This is what lets an unverified password reach the orchestrator
        // without being parked on a global first, where any reply could pick it
        // up as though it were its own.
        const requestSecret = probedPassword(inData?.id) || `${window._g.localSecret}`;

        inData["secret_store_password"] = `${requestSecret}`;
        inData["store_password"] = `${requestSecret}`;
    }

    useEffect(() => {
        function processIncommingMessage(event) {
            try {
                if (!isMobile) {
                    let eventData = {...(typeof event.data !== 'undefined') ? JSON.parse(event.data) : {}, 
                        eTimeStamp: event.timeStamp,
                        timestamp: new Date().getTime()
                    };
                    if (eventData.type == APPFACTOR.command) {
                        if (eventData.connect == true) {
                            if (!(window._g.vSock.v2.available || window._g.vSock.v1.available)) {
                                setInit(p => p + 1);
                            }

                            setTimeout(() => {
                                if (window._g.vSock.v2.available) {
                                    sendMessage(`
                                         {
                                            "type":"get_protocols",
                                            "id":"${sessionUID}"
                                         }
                                    `);
                                } else if (window._g.vSock.v1.available) {
                                    sendMessage(`
                                        {
                                            "ProtocolsRequest":{
                                               "id":"${sessionUID}",
                                               "timestamp":0
                                            }
                                         }
                                    `);
                                }
                            }, 100);
                        }
                        
                        if (window._g.connectionStatus == 'Open') {
                            if (eventData.scanRaw == true) {
                                if(window._g.vSock.v2.available){                                    
                                    setAdditionalData(eventData.payload)
                                    sendMessage(JSON.stringify(eventData.payload));
                                }
                            } else if (eventData.extract == true) {
                                let payload = ``;
                             
                                let token = poolData.refreshToken();
                                token = poolData.accessToken;

                                if (window._g.vSock.v2.available) {
                                    let payloadJ = {
                                        type     : "extract",
                                        id       : `${eventData.sessionUID  || sessionUID}`,
                                    }

                                    const assessSourceTypeName = "source_code_extract";
                                    if( eventData.apps ){
                                        payloadJ.apps = eventData.apps;
                                        payloadJ.type = "multi_extract";
                                    }else if(eventData[assessSourceTypeName]){
                                        payloadJ.type = assessSourceTypeName;

                                        payloadJ = {
                                            ...payloadJ,
                                            ...eventData[assessSourceTypeName]
                                        }
                                    }else{
                                        payloadJ = {
                                            ...payloadJ,
                                            protocol : `${eventData.protocol}`,
                                            app_id   : `${eventData.app_id}`,
                                            folder   : `${eventData.folder}`,
                                            host     : `${eventData.host}`    
                                        }
                                    }

                                    setAdditionalData(payloadJ)
                                    payload = JSON.stringify(payloadJ)
                                } else {
                                    payload = `{
                                        "${APPFACTOR.__AEX}": {
                                            "id"       :"${eventData.sessionUID  || sessionUID}",
                                            "timestamp":0,
                                            "protocol" : "${eventData.protocol}",
                                            "app_id"   :"${eventData.app_id}",
                                            "folder"   :"${eventData.folder}",
                                            "host"     :"${eventData.host}"
                                        }
                                    }`;
                                }

                                sendMessage(payload);
                            } else if (eventData.scan == true) {
                                let payload = "";

                                let token = poolData.refreshToken();
                                token = poolData.accessToken;

                                if (typeof eventData.targets !== 'undefined') {
                                    payload = JSON.stringify({
                                        type: "scan",
                                        id: eventData.sessionUID  || sessionUID,
                                        targets: eventData.targets
                                    });

                                    let payloadJ = JSON.parse(payload);
                                    setAdditionalData(payloadJ)
                                    payload = JSON.stringify(payloadJ)
                                    
                                } else if (typeof eventData.start_ip !== 'undefined') {
                                    payload = `{
                                        "type": "scan",
                                        "id":"${eventData.sessionUID  || sessionUID}",
                                        "targets":[
                                            {
                                                "type":"ip_range",
                                                "start_ip":"${eventData.start_ip}",
                                                "end_ip":"${eventData.end_ip}",
                                                "protocol_ids":${eventData.protocol}
                                            }
                                        ]
                                    }`;

                                    let payloadJ = JSON.parse(payload);
                                    setAdditionalData(payloadJ)
                                    payload = JSON.stringify(payloadJ)
                                }else if (typeof eventData.subnet === 'undefined') {
                                    if (window._g.vSock.v2.available) {
                                        payload = `{
                                            "type": "scan",
                                            "id":"${eventData.sessionUID  || sessionUID}",
                                            "targets":[
                                                {
                                                    "type":"host_list",
                                                    "hosts":${eventData.host},
                                                    "protocol_ids":${eventData.protocol}
                                                }
                                            ]
                                        }`;

                                        let payloadJ = JSON.parse(payload);
                                        setAdditionalData(payloadJ)
                                        payload = JSON.stringify(payloadJ)
                                    } else if (window._g.vSock.v1.available) {
                                        payload = `{
                                            "${APPFACTOR.__ASCAN}":{
                                                "id":"${eventData.sessionUID  || sessionUID}",
                                                "timestamp":0,
                                                "hosts":[
                                                    {
                                                        "type":"host_list",
                                                        "hosts":${eventData.host},
                                                        "protocol_ids":[
                                                            "${eventData.protocol}"
                                                        ]
                                                    }
                                                ]
                                            }
                                        }`;
                                    }
                                } else {
                                    if (window._g.vSock.v2.available) {
                                        payload = `{
                                            "type":"scan",
                                            "id":"${eventData.sessionUID  || sessionUID}",
                                            "targets":[
                                                {
                                                    "type":"cidr",
                                                    "subnet":"${eventData.subnet}",
                                                    "protocol_ids":${eventData.protocol}
                                                }
                                            ]
                                        }`;
                                    
                                        let payloadJ = JSON.parse(payload);
                                        setAdditionalData(payloadJ)
                                        
                                        payload = JSON.stringify(payloadJ)
                                    } else if (window._g.vSock.v1.available) {
                                        payload = `{
                                            "${APPFACTOR.__ASCAN}":{
                                                "id":"${sessionUID}",
                                                "timestamp":0,
                                                "hosts":[
                                                    {
                                                        "type":"cidr",
                                                        "subnet":"${eventData.subnet}",
                                                        "protocol_ids":[
                                                            "${eventData.protocol}"
                                                        ]
                                                    }
                                                ]
                                            }
                                        }`;
                                    }
                                }
        
                                sendMessage(payload);
                            }
                        }
                    }
                    else if(eventData.type  == "progress"){
                            if( eventData.app_id ){
                                if(typeof window._g.eventLog === "undefined"){
                                    window._g.eventLog = []
                                }

                                window._g.eventLog.push(eventData)
                            }
                    }
                }
            } catch (e) {/* */ }
        }

        window.addEventListener("message", processIncommingMessage, false);

        // Previously used to restore minimized state from localStorage and adjust watermark margin.
        // menuLow logic removed; sidebar remains full width.
    }, []);

    const handleLogout = () => {
        logout();
        
        navigate("/", { replace: true });
    };

    const activateD = useCallback((elem) => {
        try {
            document.querySelectorAll(".wrapper1 .left-side a").forEach(e => e.classList.remove('active'));
            let el = elem.target;

            while (el.tagName !== "A") {
                el = el.parentNode;
            }

            el.classList.add("active");
            let route = "#";

            route = el.getAttribute("data-val");

            if (route !== "#") {
                navigate(route);
            }
        } catch (e) {
            console.log(e);
        }
    }, [navigate]);

    /* The socket's traffic is relayed to the page from here, once per message.
       gdata only says how to read the payload, but listing it as a dependency
       re-ran this effect every time anything called setGdata - which replaces
       the object wholesale - and the same message was posted again. The scan
       page reads those posts as progress, so a host's line appeared twice and
       its message counters ran ahead of the scan. The version is read through a
       ref, and the message just relayed is remembered so a re-run cannot send
       it a second time. */
    const gdataRef = useRef(gdata);
    /* what the orchestrator has sent since this page loaded, and the timer that
       publishes it - see the relay effect below */
    const wsCountRef = useRef(0);
    const wsPublishRef = useRef(0);
    gdataRef.current = gdata;
    const relayedRef = useRef(null);

    useEffect(() => {
        async function getData(inData) {
            if (gdataRef.current?.version == 1) {
                let a = await inData.text();

                return a;    
            } else {
                return inData;
            }
        }

        if (lastMessage && relayedRef.current !== lastMessage) {
            relayedRef.current = lastMessage;

            /* How many the orchestrator has sent, for the line under Scan's
               title. Counted in a ref and published at most once a second: the
               progress bursts arrive faster than React should be asked to
               re-render, which is why Scan throttles them too. */
            wsCountRef.current += 1;
            try { window._g.wsMessages = wsCountRef.current; } catch (e) { /**/ }
            if (!wsPublishRef.current) {
                wsPublishRef.current = setTimeout(() => {
                    wsPublishRef.current = 0;
                    setGdata(p => (p.wsMessages === wsCountRef.current
                        ? p
                        : { ...p, wsMessages: wsCountRef.current }));
                }, 1000);
            }

            getData(lastMessage.data).then(msgData => {
                try {
                    if (msgData[0] != '"') {
                        window.postMessage(msgData);
                       
                        let msg = JSON.parse(msgData);
                        if (typeof msg[APPFACTOR.__AEXP] !== 'undefined') {
                            window._g.modTM_RUNS[msg[APPFACTOR.__AEXP].app_id].progress = msg[APPFACTOR.__AEXP].progress.message;
                        }

                        if (`${msg.type}` == 'protocols') {
                            window._g.protocols = msg.protocols;
                        }

                        if (typeof msg[APPFACTOR.__PRES] !== 'undefined') {
                            window._g.protocols = msg[APPFACTOR.__PRES].protocols;
                        }
                    }
                } catch (e) {/**/ }
            });
        }
    }, [lastMessage, setGdata]);

    /* the pending publish must not outlive the rail */
    useEffect(() => () => clearTimeout(wsPublishRef.current), []);

    // Removed dynamic presentation width syncing with minimized state

    const checkIfMobile = () => [/iPhone/i, /iPad/i, /Android/i, /webOS/i, /BlackBerry/i, /Windows Phone/i].some((item) => navigator.userAgent.match(item));

    let mEnabled = !checkIfMobile();

      const mBottom = 80
    return (
        <>
        <div style={{
            
    position: "absolute",
    bottom: "calc(0.24vw)",
    left: "6px",
    width: "50%",
    height: "12px",
    fontSize: "0.42vw",
    fontWeight: "bold",
    textAlign: "left",
    zIndex: 1000,
    maxWidth: "50%",
    color:isDarkMode ? '#FFF' : '#000'
    }}>{window.APPFACTOR_VERSION}</div>
            <div
                className={"wrapper1"}
                style={{
                    background: "transparent",
                    color: isDarkMode ? "rgba(255,255,255,0.84)" : "rgba(0,0,0,0.8)",
                    minHeight: 580,
                    position: "relative",
                    width: "102px",
                }}
            >
                <div className="wrp"></div>
                

                <div
                    className="left-side"
                    style={{
                        width: "102px",
                        backgroundColor: isDarkMode ? '#000' : 'rgb(251,251,251)',
                        color: isDarkMode ? '#FFF' : '#000'
                    }}
                >
                    <div className="side-wrapper">
                        <div className="side-title"  style={{
                            marginBottom: mBottom,
                            display: 'flex',
                            justifyContent: 'center'
                        }}>
                            <div
                                ref={logoReff}
                                id="menu-toggle"
                                className={`appf-logo2${showWindow ? " is-asking" : ""}`}
                                onMouseEnter={() => {
                                    clearTimeout(askHoverTimer.current);
                                    askHoverTimer.current = setTimeout(openEstateAsk, 2000);
                                }}
                                onMouseLeave={() => clearTimeout(askHoverTimer.current)}
                                style={{
                                    position: 'relative',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    marginTop: 0,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                                onClick={() => {
                                    /* The mark is the way in to what the estate
                                       can answer - see ESTATE_QUESTIONS. */
                                    clearTimeout(askHoverTimer.current);
                                    openEstateAsk();
                                }}
                                role="button"
                                /* the page is driven by the pointer and by the
                                   keys the menu lists; Ctrl three times is this
                                   control's keyboard route, so it takes no tab
                                   stop of its own */
                                tabIndex={-1}
                                aria-haspopup="true"
                                aria-expanded={showWindow}
                                title="What would you like to see?"
                            >

                               <EstateMark />
                               {/* the cards' own travelling hairline, run
                                   round the mark's outer edge */}
                               <span className="estate-mark__sweep" aria-hidden="true" />
                               {SSS_}
                                {/* <div style={{
                                    maxWidth: menuLow ? "calc(33%)" : "114px",
                                    position: "absolute",
                                    overflow: "hidden",
                                    marginTop: !menuLow ? 68 : 48,
                                    paddingLeft: !menuLow ? 0 : 0,
                                    marginLeft: menuLow ? 0 : 6,
                                    width: 180,
                                    textTransform: "uppercase",
                                    textAlign: "left",
                                    color: "grey",
                                }}>
                                    {!isMobile && window.innerWidth > 900 ?
                                        <>
                                            <div
                                                style={{
                                                    fontSize: 12
                                                }}
                                            >
                                                {localStorage.getItem("tenantData")? JSON.parse(localStorage.getItem("tenantData")).tenant:""}
                                            </div>

                                            <div
                                                style={{
                                                    fontSize: 8
                                                }}
                                            >
                                                {localStorage.getItem("tenantData")?JSON.parse(localStorage.getItem("tenantData")).username:""}
                                            </div>
                                        </>
                                        :
                                        <></>
                                    }
                                </div> */}
                            </div>

                            <StyledMenu
                                anchorEl={logoRef}
                                open={showWindow}
                                onClose={closeEstateAsk}
                                /* Beside the mark rather than under it: the
                                   rail is 102px wide and the questions are
                                   sentences, so a menu hung below it covered
                                   the nav it came from. The shared StyledMenu
                                   keeps its own corners - these are this
                                   instance's. */
                                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                                transformOrigin={{ vertical: "top", horizontal: "left" }}
                                MenuListProps={{
                                    "aria-labelledby": "menu-toggle",
                                    className: "estate-ask",
                                }}
                                /* painted by estate-ask.css rather than by the
                                   MUI theme: the theme behind this menu reports
                                   white ink while its paper paints white, which
                                   is how the questions came out invisible */
                                PaperProps={{ className: "estate-ask__paper" }}
                            >
                                <div className="estate-ask__head">
                                    <span>What would you like to see?</span>
                                    <span className="estate-ask__hint">press a number</span>
                                </div>
                                <Divider sx={{ my: 0.5 }} />
                                {ESTATE_QUESTIONS.map((q, i) => (
                                    <MenuItem
                                        key={q.to}
                                        className="estate-ask__item"
                                        onClick={() => askQuestion(q)}
                                        disableRipple
                                    >
                                        {/* the number is the key that fires it */}
                                        <span className="estate-ask__key">{i + 1}</span>
                                        <span className="estate-ask__label">{q.label}</span>
                                    </MenuItem>
                                ))}

                            </StyledMenu>

                            {/* ...and what listening looks like, which outlives
                                the menu that started it */}
                            <EstateVoicePill />

                            <SettingsDialog
                                open={settingsOpen}
                                onClose={() => setSettingsOpen(false)}
                                isDarkMode={isDarkMode}
                                /* whether the orchestrator is reachable at all,
                                   which is what its settings group says when
                                   there is nothing to configure */
                                connected={gdata?.connected}
                            />

                            <LogoutWarning
                                open={logoutAsking}
                                onClose={() => setLogoutAsking(false)}
                                onLogout={() => { setLogoutAsking(false); handleLogout(); }}
                                isDarkMode={isDarkMode}
                            />
                        </div>
                        <ProjectInfoBar/>
                        <div
                            className={"side-menu"}
                            style={{ paddingTop: 0 }}
                        >
                            <a data-val="./dashboard" onClick={activateD}>
                                <div
                                    className="icon"
                                    style={{ marginLeft: -2, marginTop: 4 }}
                                >
                                    {NavDashboard}
                                </div>
                                <div className="menu-label">{"Dashboard"}</div>
                            </a>

                            <a data-val="./discovery" onClick={activateD}
                            onDoubleClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if(e.shiftKey && e.altKey){
                                    navigate("./traceability");
                                } 

                            }}
                            >
                                <div
                                    className="icon"
                                    style={{ marginLeft: -1.5, marginTop: 5 }}
                                >
                                    {NavDiscovery}
                                </div>
                                <div className="menu-label">{"Discovery"}</div>
                            </a>

                            <a data-val="./apps" onClick={activateD}>
                                <div
                                    className="icon"
                                    style={{marginLeft: -1.5, marginTop: 5 }}
                                >
                                    {NavApp}
                                </div>
                                <div className="menu-label">{"App"}</div>
                            </a>

                            {deployEnabled  &&
                            <a data-val="./designer" onClick={activateD} >
                                <div
                                    className="icon"
                                    style={{ marginLeft: -1.5, marginTop: 14 }}
                                >
                                  {NavDesigner}
                                </div>
                                <div className="menu-label">{"Designer"}</div>
                            </a>
                            }

                            {deployEnabled &&
                            <a data-val="./deploy" onClick={activateD} >
                                <div
                                    className="icon deploy"
                                    style={{ marginLeft: -1.5, marginTop: 5 }}
                                >
                                    <div style={{
                                        transform: "scale(1.6)",
                                        transformOrigin: "8px 8px"
                                    }}>
                                    {NavDeploy}
                                    </div>
                                </div>
                                <div className="menu-label">{"Deploy"}</div>
                            </a>
                            }
                                <a data-val="./eventlog" onClick={activateD} >
                                    <div
                                        className="icon"
                                        style={{ marginLeft: -1.5, marginTop: 5 }}
                                    >
                                        {NavEventLog}
                                    </div>
                                    <div className="menu-label">{"Events log"}</div>
                                </a>
    

                            {isForgeEnabled() && (
                            <a data-val="./forge" onClick={activateD}>
                                <div className="icon" style={{ marginLeft: -1.5, marginTop: 4 }}>
                                    {NavForge}
                                </div>
                                <div className="menu-label">{"Forge"}</div>
                            </a>
                            )}

                            <a data-val="./multiverse" onClick={activateD}>
                                <div
                                    className="icon"
                                    style={{
                                        marginLeft: -1.5,
                                        marginTop: 4
                                    }}
                                >
                                    {NavMultiverse}
                                </div>
                                <div className="menu-label">{"Multiverse"}</div>
                            </a>

                            <a data-val="./security" onClick={activateD}>
                                <div
                                    className="icon"
                                    style={{
                                        marginLeft: -1.5,
                                        marginTop: 4
                                    }}
                                >
                                    {NavSecurity}
                                </div>
                                {/* one line, like every other label: the rail's
                                    label now has the full width to sit in */}
                                <div className="menu-label">Security Blast</div>
                            </a>

                            <a
                                data-val="./monitor"
                                className="monitor"
                                style={{ display: "none" }}
                                onClick={activateD}
                            >
                                <div
                                    className="icon"
                                    style={{
                                        marginLeft: -1.5,
                                        marginTop: 6
                                    }}
                                >
                                    {NavMonitor}
                                </div>
                                <div className="menu-label">{"Monitor"}</div>
                            </a>

                            {mEnabled ?
                                <>
                                    <a
                                        data-val="./scan"
                                        // className={connectionStatus == "Open" ? " connected active" : ""}
                                        onContextMenu={() => {}}
                                        onClick={(ev) => {
                                            if (!isMobile) {
                                                if (ev.shiftKey == true) {
                                                    ev.stopPropagation()
                                                    {
                                                        setAnchorElScan(document.querySelector('a[data-val="./scan"]'));
                                                    }
                                                } else {
                                                    if (!(vSock.v2.available || vSock.v1.available)) {
                                                        setInit(p => p + 1);
                                                    }

                                                    if (window._g.vSock.v2.available) {
                                                        sendMessage(`{
                                                            "type":"get_protocols",
                                                            "id":"${sessionUID}"
                                                            }`
                                                        );
                                                    } else if (window._g.vSock.v1.available) {
                                                        sendMessage(`{
                                                            "ProtocolsRequest":{
                                                                "id":"${sessionUID}",
                                                                "timestamp":0
                                                            }
                                                        }`);
                                                    }
                                                }
                                            }

                                            activateD(ev);
                                        }}
                                    >
                                        <div
                                            className="icon"
                                            style={{
                                                filter: connectionStatus == "Open" ? "" : "grayscale(100%)",
                                                position: "relative"
                                            }}
                                        >
                                            <div className="oversion">
                                                {(connectionStatus == "Open" ? (currentWSURL.endsWith("ws/v2")?"v2":"v1") : "")}
                                            </div>

                                            {NavScan}
                                        </div>
                                        
                                        <div className="menu-label">{"Scan"}</div>
                                    </a>

                                    

                                    <Menu
                                        className="scanMenu"
                                        id="scanMenu"
                                        anchorEl={anchorElScan}
                                        open={anchorElScan != null}
                                        onClose={() => setAnchorElScan(null)}
                                    >
                                        <div
                                            className="mstep active"
                                            style={{
                                                margin: 20,
                                                marginTop: 0,
                                                marginBottom: 0,
                                                height: 150,
                                                maxWidth: 402,
                                                minWidth: 402
                                            }}
                                        >
                                            <div
                                                className="asset421"
                                                style={{
                                                    margin: 0,
                                                    fontFamily: "InterL",
                                                    fontSize: 20,
                                                    marginBottom: 30
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        marginLeft: -9,
                                                        marginTop: -9,
                                                        borderRadius: "99em",
                                                        paddingLeft: 7,
                                                        paddingTop: 7,
                                                        paddingBottom: 0,
                                                        paddingRight: 4,
                                                        border: "0.42px solid rgba(255,255,255,0.242)",
                                                        filter: "drop-shadow(1px 1px 11px rgba(255,255,255,0.42)) grayscale(100%) brightness(1.75)",
                                                        opacity: 0.842
                                                    }}
                                                >
                                                    {NavScan}
                                                </div>

                                                <span
                                                    style={{
                                                        paddingLeft: 106,
                                                        fontSize: 16,
                                                        textShadow: "2px 0 4px #000000",
                                                        color: "rgba(255,255,255,0.942)"
                                                    }}
                                                >
                                                    Change Scan Settings
                                                </span>
                                            </div>

                                            <div
                                                style={{
                                                    zIndex: 22,
                                                    fontSize: 14,
                                                    margin: 10,
                                                    marginTop: 15
                                                }}
                                            >
                                                <span
                                                    style={{ marginRight: 28 }}
                                                >
                                                    WS - URL
                                                </span>

                                                <span>
                                                    <input
                                                        id="idwsurl"
                                                        data={localStorage.wsURL || APPFACTOR.__DEFAULT_WS_URL}
                                                        defaultValue={localStorage.wsURL || APPFACTOR.__DEFAULT_WS_URL}
                                                    />
                                                </span>
                                            </div>

                                            <div
                                                style={{
                                                    zIndex: 22,
                                                    fontSize: 14,
                                                    margin: 10,
                                                    marginTop: 28
                                                }}
                                            >
                                                <span
                                                    style={{ marginRight: 28 }}
                                                >
                                                    WS - port
                                                </span>

                                                <span>
                                                    <input
                                                        id="idwsport"
                                                        defaultValue={localStorage.wsPort || APPFACTOR.__DEFAULT_PORT}
                                                    />
                                                </span>
                                            </div>

                                            <div
                                                style={{
                                                    marginTop: 0
                                                }}
                                                className="wButton save"
                                                onClick={() => {
                                                    let wsport = "";
                                                    let oldwsport = "";
                                                    let wsurl = "";
                                                    let oldwsurl = "";

                                                    try {
                                                        let wsportEL = document.getElementById("idwsport");
                                                        wsport = wsportEL.value;
                                                        oldwsport = wsportEL.getAttribute("data");

                                                        if (wsport !== "" && parseInt(wsport) && parseInt(wsport) > 0 && parseInt(wsport) < 65535) {
                                                            localStorage.wsPort = wsport;
                                                        }
                                                    } catch (e) { /**/ }

                                                    try {
                                                        let wsurlEL = document.getElementById("idwsurl");
                                                        wsurl = wsurlEL.value;
                                                        oldwsurl = wsurlEL.getAttribute("data");

                                                        let validWS = new RegExp('^(wss?:\\\/\\\/)([0-9]{1,3}(?:\\.[0-9]{1,3}){3}|[^\\\/]+)$', 'gm');

                                                        if (validWS.test(wsurl)) {
                                                            localStorage.wsURL = wsurl;
                                                        }
                                                    } catch (e) {/**/ }

                                                    setAnchorElScan(null);
                                                }}
                                            >
                                                Save
                                            </div>

                                            <div
                                                style={{
                                                    marginTop: 0
                                                }}
                                                className="wButton cancel"
                                                onClick={() => {
                                                    setAnchorElScan(null);
                                                }}
                                            >
                                                Cancel
                                            </div>
                                        </div>
                                    </Menu>
                                </>
                                :
                                <></>
                            }

                            {/* Reports opens a menu rather than going anywhere,
                                so it has no route to be known by: it carries
                                its own id and its own label instead, which is
                                what puts it in the menu-entries list with the
                                rest (see navEntries). */}
                            <a data-nav-id="./reports">
                                <Button
                                    className="repMenu"
                                    style={{
                                        width: 90,
                                        height: 42,
                                        marginLeft: -6,
                                        zIndex: 0,
                                        backgroundColor: "transparent",
                                        textTransform: "unset",
                                    }}
                                    id="demo-customized-button"
                                    aria-controls={open ? "demo-customized-menu" : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? "true" : undefined}
                                    variant="contained"
                                    disableElevation
                                    onClick={handleClick}
                                    startIcon={
                                        <div
                                            className="icon"
                                            style={{ marginLeft: 6, marginTop: 1 }}
                                        >
                                            {NavReports}
                                        </div>
                                    }
                                >
                                    <span data-nav-text>{"Reports"}</span>
                                </Button>

                                <Menu
                                    id="demo-customized-menu"
                                    /* the row menu the applications table opens:
                                       same card, same head, same entries */
                                    className="actionMenuItems"
                                    MenuListProps={{
                                        "aria-labelledby": "demo-customized-button"
                                    }}
                                    slotProps={{ paper: { className: "orion-tokens" } }}
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                >
                                    <div className="row-menu__head">
                                        <span className="row-menu__badge">{NavReports}</span>
                                        <span className="row-menu__who">
                                            <b className="row-menu__name">Reports</b>
                                        </span>
                                    </div>

                                    <MenuItem
                                        onClick={() => {
                                            try {
                                                let token = poolData.refreshToken();
                                                token = poolData.accessToken;
                                                let repAPI = getApiUrl(poolData.envURL);

                                                const osEOLReport = `os-eol-report`;
                                                fetch(`${repAPI}/reports/${osEOLReport}`, {
                                                    headers: {
                                                        authorization: token ? `Bearer ${token}` : '',
                                                        "X-Project-Id": `${currentProjectId}`,
                                                        "X-Environment-Id":`${currentSEnv}`
                                                    }
                                                })
                                                    .then((response) => response.blob())
                                                    .then((data) => {
                                                        const element = document.createElement("a");
                                                        element.href = URL.createObjectURL(data);
                                                        element.download = `${osEOLReport}.csv`;
                                                        document.body.appendChild(element); // Required for this to work in FireFox
                                                        element.click();
                                                    });
                                            } catch (e) {/* */}

                                            setAnchorEl(null);
                                        }}
                                        disableRipple
                                    >
                                        <div className="row-menu__item">
                                            <span className="row-menu__icon"><FileCopyIcon /></span>
                                            OS EOL report
                                        </div>
                                    </MenuItem>

                                    <MenuItem
                                        onClick={() => {
                                            try {
                                                let token = poolData.refreshToken()
                                                token = poolData.accessToken;
                                                let repAPI = getApiUrl(poolData.envURL);
                                                const installedSoftwareEOLReport = `installed-packages-eol-report`;

                                                fetch(`${repAPI}/reports/${installedSoftwareEOLReport}`, {
                                                    headers: {
                                                        authorization: token ? `Bearer ${token}` : '',
                                                        "X-Project-Id": `${currentProjectId}`,
                                                        "X-Environment-Id":`${currentSEnv}`
                                                    }
                                                })
                                                    .then((response) => response.blob())
                                                    .then((data) => {
                                                        const element = document.createElement("a");
                                                        element.href = URL.createObjectURL(data);
                                                        element.download = `${installedSoftwareEOLReport}.csv`;
                                                        document.body.appendChild(element); // Required for this to work in FireFox
                                                        element.click();
                                                    });
                                            } catch (e) {/* */}

                                            setAnchorEl(null);
                                        }}
                                        disableRipple
                                    >
                                        <div className="row-menu__item">
                                            <span className="row-menu__icon"><ArchiveIcon /></span>
                                            Software EOL report
                                        </div>
                                    </MenuItem>
                                </Menu>
                            </a>

                            {/* Settings, under the rest of the estate and above
                                the way out: it is a door off the rail rather
                                than a step in any task, and it used to be
                                behind the dashboard's edit bar - which meant
                                editing a board to change how the tabs are
                                drawn. */}
                            <a
                                className="settings-nav"
                                onClick={() => setSettingsOpen(true)}
                                title="Settings"
                            >
                                <div
                                    className="icon"
                                    style={{ marginLeft: -1, marginTop: 4 }}
                                >
                                    <svg width={22} height={22} viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                        <circle cx={12} cy={12} r={3.2} />
                                        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6h.09A1.65 1.65 0 0 0 10 3.09V3a2 2 0 0 1 4 0v.09A1.65 1.65 0 0 0 15 4.6a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9v.09a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z" />
                                    </svg>
                                </div>

                                <div className="menu-label">{"Settings"}</div>
                            </a>

                            <a
                                className="logout"
                                /* Asked first: everything this browser is
                                   keeping goes with the session, and a
                                   preference that disappears without a word is
                                   one nobody sets twice. */
                                onClick={() => setLogoutAsking(true)}
                                title="Logout"
                            >
                                <div
                                    className="icon"
                                    style={{ marginLeft: -1, marginTop: 4 }}
                                >
                                    {NavLogout}
                                </div>

                                <div className="menu-label">{"Logout"}</div>
                            </a>

                            {/* What the product is made of, as a page, and the
                                butler beside it. Both are built for the people
                                building this and neither is something a
                                customer opening the product should be shown, so
                                both are behind the chord. See backstage.js. */}
                            {backstage && (<>
                            <a
                                className="site-content-nav"
                                onClick={() => navigate("/content")}
                                title="Content — every page and filter in this product"
                            >
                                <div
                                    className="icon"
                                    style={{ marginLeft: -1, marginTop: 4 }}
                                >
                                    <svg width={22} height={22} viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" strokeWidth={1.7} strokeLinecap="round"
                                        strokeLinejoin="round" aria-hidden="true">
                                        <rect x="2.6" y="3.2" width="7.2" height="5.4" rx="1.2" />
                                        <rect x="14.2" y="3.2" width="7.2" height="5.4" rx="1.2" />
                                        <rect x="8.4" y="15.4" width="7.2" height="5.4" rx="1.2" />
                                        <path d="M6.2 8.6v3.2h11.6V8.6M12 11.8v3.6" />
                                    </svg>
                                </div>

                                <div className="menu-label">{"CNT"}</div>
                            </a>

                            {/* The butler: a model on this machine. Beside the
                                content map because the two are the same idea -
                                one draws what the product is made of, the other
                                answers questions about it. */}
                            <a
                                className="butler-nav"
                                onClick={() => navigate("/butler")}
                                title="Butler — a model that runs on this machine"
                            >
                                <div
                                    className="icon"
                                    style={{ marginLeft: -1, marginTop: 4 }}
                                >
                                    <svg width={22} height={22} viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" strokeWidth={1.7} strokeLinecap="round"
                                        strokeLinejoin="round" aria-hidden="true">
                                        <circle cx="12" cy="8.2" r="3.6" />
                                        <path d="M5 20.2c0-3.4 3.1-5.6 7-5.6s7 2.2 7 5.6" />
                                        <path d="M9.4 14.9 12 18l2.6-3.1" />
                                    </svg>
                                </div>

                                <div className="menu-label">{"Butler"}</div>
                            </a>
                            </>)}
                        </div>
                    </div>

                    {(<ThemeToggler enabled={localStorage.getItem('themeToggleEnabled') === 'true'}/>)}
                </div>
            </div>
        </>
    );
}

export default SidebarNav;